const styles = theme => ({
  root: {
    padding: theme.spacing(4, 2),
  },
  text: {
    color: theme.palette.white,
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
    fontSize: '1rem',
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
  },
  success: {
    backgroundColor: theme.palette.success.main,
  },
  info: {
    backgroundColor: theme.palette.info.main,
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
  },
  error: {
    backgroundColor: theme.palette.error.main,
  },
})

export default styles
